import { Component, Input, Inject, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { emitedEventsTypes } from '@src/constants';
import { dashboardActions } from '@src/store/reducers/dashboardReducer';
import { ActivityDataSource } from './activity.data-source';
import { SessionService} from '@src/services';

@Component({
    selector: 'activities',
    template: require('./activities.component.html'),
    styles: [require('./activities.component.scss')]
})
export class ActivitiesComponent implements OnInit, OnDestroy {
    @Input() public projectId: string;

    public isEditing = false;
    public toggle = false;
    public periods = null;
    public selectedPeriod = 7;
    public showActivities = true;
    public activities: ActivityDataSource;

    constructor(
        @Inject('$scope') private $scope: any,
        @Inject('$filter') private $filter: any,
        private sessionService:SessionService,
        private store: Store) {
    }

    public async ngOnInit() {
        
        const projectId = parseInt(this.projectId, 10);
        this.activities = new ActivityDataSource(this.store, this.$filter, projectId, this.selectedPeriod);
        this.sessionService.UpdateActivitySubject$.subscribe(data =>{
            if(data){
                this.loadActivities();
            }
        })
        
        const unsubscribe = this.store.subscribe(() => {
            this.isEditing = !this.store.getState().project.editMode;
            const timePeriods: string[] = this.store.getState().dashboard.filterPeriods;
            if (timePeriods && this.periods == null) {
                this.periods = Object.keys(timePeriods).map(key => ({ key, value: timePeriods[key] }));
                unsubscribe();
            }
        });
        await this.store.dispatch({ type: dashboardActions.GET_TIME_PERIODS });
        this.$scope.$on(emitedEventsTypes.openActivitiesWindow, () => this.toggle ? '' : this.toggleActivities());
    }

    public ngOnDestroy() {
        this.activities.disconnect();
    }

    public toggleActivities() {
        this.toggle = !this.toggle;
        if (this.toggle) {
            this.loadActivities();
        }
    }

    public loadActivities() {
        this.showActivities = false; // We have to hide the list to apply updates
        const resetActivities = async () => {
            this.showActivities = true;
            await this.activities.reset(this.selectedPeriod);
        };
        setTimeout(resetActivities, 0);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/activities/activities.component.ts